import { render, staticRenderFns } from "./saveitemM.vue?vue&type=template&id=7b7423d6&scoped=true"
import script from "./saveitemM.vue?vue&type=script&lang=js"
export * from "./saveitemM.vue?vue&type=script&lang=js"
import style0 from "./saveitemM.vue?vue&type=style&index=0&id=7b7423d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7423d6",
  null
  
)

export default component.exports